
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacypolicy/20190916",
      function () {
        return require("private-next-pages/privacypolicy/20190916/index.js");
      }
    ]);
  